import { render, staticRenderFns } from "./smLoader.vue?vue&type=template&id=b22cc53a&"
import script from "./smLoader.vue?vue&type=script&lang=js&"
export * from "./smLoader.vue?vue&type=script&lang=js&"
import style0 from "./smLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports